"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __importStar(require("@gin-betting/core"));
var joinIdPath = core_1.default.utils.joinIdPath;
function handleCreateBetsRequest(state, action) {
    var _a = action.payload, args = _a.args, variables = _a.variables;
    if (!args)
        return state;
    var betslipBetId = args.betslipBetId;
    var betslipBets = state.betslipBets, betslipOdds = state.betslipOdds;
    var betslipBet = betslipBets.get(betslipBetId);
    if (!betslipBet)
        return state;
    var nextBetslipOdds = betslipOdds;
    var nextBetslipOddIds = betslipBet.betslipOddIds;
    var odds = variables.odds;
    odds.forEach(function (odd) {
        var matchId = odd.matchId, marketId = odd.marketId, oddId = odd.oddId, ratio = odd.ratio;
        var betslipOddPath = joinIdPath(matchId, marketId, oddId, betslipBetId);
        var betslipOdd = betslipOdds.get(betslipOddPath);
        if (!betslipOdd) {
            nextBetslipOddIds = nextBetslipOddIds.delete(betslipOddPath);
        }
        else {
            var nextBetslipOdd = __assign(__assign({}, betslipOdd), { singleStatus: core_1.App.BetslipStatus.PROCESSING, fixedCoef: ratio });
            nextBetslipOdds = nextBetslipOdds.set(nextBetslipOdd.id, nextBetslipOdd);
        }
    });
    var nextBetslipBet = __assign(__assign({}, betslipBet), { betslipOddIds: nextBetslipOddIds });
    var nextBetslipBets = betslipBets.set(nextBetslipBet.id, nextBetslipBet);
    return state
        .set('betslipBets', nextBetslipBets)
        .set('betslipOdds', nextBetslipOdds);
}
exports.default = handleCreateBetsRequest;
//# sourceMappingURL=handleCreateBetsRequest.js.map